export default __webpack_public_path__ + "static/media/icons8-facebook1.815fc4fe.svg";